import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  blackShade05,
  blackShade19,
  border25,
  borderTextBoxColor,
  greyColor42,
  greyColor47,
  mobilePrimary,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { MOBILE_VARIANT_PRODUCT_TABLE_HEADER } from "../../../utils/data";
import { textOneLines } from "../../../utils/styles";
import VariantDataPreviewPopup from "../Popup/VariantDataPreviewPopup";

function MobileVariantDetails({ header, variantData }) {
  const [showMore, setShowMore] = useState(null);

  return (
    <Box sx={styles.card}>
      <Typography sx={styles.title}>Variance Details</Typography>
      <Box sx={styles.tableWrapper}>
        <TableContainer sx={styles.tableContainer} component={Box}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky !important",
                  top: 0,
                  backgroundColor: greyColor42,
                  zIndex: 20,
                  borderRadius: "8px 8px 0 0",
                }}
              >
                {header?.map((item, index) => {
                  return (
                    <TableCell key={item.id} sx={styles.tableCell}>
                      <Box
                        display={index === 0 ? "flex" : "inline-block"}
                        alignItems="center"
                        gap={1.2}
                      >
                        <Box sx={{ fontSize: 12 }}>{item?.title}</Box>
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: whiteColor }}>
              {variantData?.map((product, index) => (
                <TableRow
                  key={index}
                  sx={{
                    borderBottom: `1px solid ${borderTextBoxColor}`,
                    verticalAlign: "top",
                  }}
                >
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={product?.variant1?.inputValue} />
                  </TableCell>
                  {product?.variant2 && (
                    <TableCell sx={styles.tableBodyCell}>
                      <TableInputPreview data={product?.variant2?.inputValue} />
                    </TableCell>
                  )}
                  {product?.variant3 && (
                    <TableCell sx={styles.tableBodyCell}>
                      <TableInputPreview data={product?.variant3?.inputValue} />
                    </TableCell>
                  )}
                  <TableCell sx={styles.tableStickyRightCell}>
                    <Typography
                      sx={styles.moreLink}
                      onClick={() => setShowMore({ show: true, product })}
                    >
                      More
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {showMore && (
        <VariantDataPreviewPopup
          openModal={showMore?.show}
          product={showMore?.product}
          setOpenModal={setShowMore}
        />
      )}
    </Box>
  );
}

export default MobileVariantDetails;

const TableInputPreview = ({ data }) => {
  return (
    <Typography
      variant="body1"
      title={data}
      sx={{ ...styles.prodNameBox, ...textOneLines }}
    >
      {data || "-"}
    </Typography>
  );
};

const styles = {
  card: {
    backgroundColor: whiteColor,
    borderRadius: "13px",
    border: border25,
    boxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
    p: "15px 15px 15px",
    mb: 2,
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    mb: "10px",
    color: blackShade19,
  },
  tableWrapper: {
    width: { md: "calc(100vw - 310px)", xs: "100%" },
    borderRadius: "8px",
    border: `1px solid ${borderTextBoxColor}`,
  },
  tableContainer: {
    borderRadius: "8px",
    overflow: "scroll",
    maxHeight: "calc(100vh - 370px)",
    maxWidth: "100%",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },
  tableCell: {
    color: greyColor47,
    fontSize: "12.5px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor42,
    borderRight: `1px solid ${whiteColor}`,
    ":last-child": { position: "sticky", right: "-3px" },
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset `,
  },
  tableBodyCell: {
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "8px 15px !important",
    borderRight: `1px solid ${borderTextBoxColor}`,
  },
  prodNameBox: {
    whiteSpace: "normal",
    fontSize: 12,
    fontWeight: 500,
    color: blackShade19,
    lineHeight: "16px",
  },
  moreLink: {
    whiteSpace: "normal",
    fontSize: 12,
    fontWeight: 500,
    color: mobilePrimary,
    lineHeight: "16px",
    cursor: "pointer",
    textDecoration: "underline",
  },
  tableStickyRightCell: {
    position: "sticky",
    right: 0,
    zIndex: 12,
    boxShadow: `1px 0 0 0 ${borderTextBoxColor} inset`,
    backgroundColor: whiteColor,
    whiteSpace: "nowrap",
    color: blackShade05,
    padding: "8px 15px !important",
  },
};
